export const INIT_APP = 'INIT_APP';
export const INIT_APP_SUCCESS = 'INIT_APP_SUCCESS';
export const INIT_APP_FAIL = 'INIT_APP_FAIL';

export const INIT_ORG = 'INIT_ORG';
export const INIT_ORG_SUCCESS = 'INIT_ORG_SUCCESS';
export const INIT_ORG_FAIL = 'INIT_ORG_FAIL';

export const RESET_STATE = 'RESET_STATE';
